import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const CargoClaim = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="CargoClaim" />
                    <HerosectionsAll ScreenName="Cargo Claim" ScreenSearch="Indemnity" />

                    <div className="row col-lg-11 mx-auto p-2 p-lg-5 my-5">
                        <div className="col-12 p-lg-5 p-4 faint " style={{ textAlign: 'justify', }}>
                            <h5 className="fw-bold gray_color pb-3">Cargo Claims</h5>

                            <p>Transit Insurance policies are issued covering “All Risks” i.e. Institute Cargo Clauses (A) or against the Named Perils i.e. Institute Cargo Clauses (B) or Institute Cargo Clauses (C).  Claim under the policy will be governed by cover and exclusions of these clauses in addition to the other conditions and warranties (Express & Implied) of the said insurance contract. Relation between the Marine Insurance Act 1906 (MIA) (as amended 2015) and the policy of insurance is shown in the following diagram.   </p>
                            <div className="bg-white mt-5">
                                <img src="Static/Assets/Img/services/CARGO_CLAIMS-02.jpg" alt="" className="Hull_claims_img" />
                            </div>
                            <p className="pt-5">We assist our clients in the interpretation of the policy contract wordings and application of the same to the submitted claims. We assist in the over all claim management by handling claim documentation, claim communication, presentation of the claim to the concern authorities and advise on the protection of the recovery rights of the underwriters.</p>
                        </div>

                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
